import { Button, Modal, Steps } from 'antd';
import React, { useState } from 'react';
import { StepsStyle } from './styles';
import { CloseOutlined } from '@ant-design/icons';
import { maskDate } from '../../../../utils/mask';

const ModalStatus: React.FC<any> = ({ props, children }) => {
  const [isModalVisibleStatus, setIsModalVisibleStatus] = useState(false);
  const [handleStatus, setIsHandleStatus] = useState<any>();
  const { Step } = Steps;
  const showModalStatus = (itemMoving: any) => {
    setIsModalVisibleStatus(true);
    let activeStep = 0;
    switch (itemMoving.status) {
      case 'ANFC':
        activeStep = 0;
        break;
      case 'CR':
        activeStep = 1;
        break;
      default:
        activeStep = 0;
        break;
    }

    setIsHandleStatus(
      <Steps direction="vertical" size="small" current={activeStep} progressDot>
        <Step
          title="Aguardando Nota de Cobertura"
          description={activeStep >= 0 && maskDate(itemMoving.dhAguardandoNFCobertura)}
        />
        <Step
          title={'Cobertura Realizada'}
          description={activeStep >= 1 && maskDate(itemMoving.dhCoberturaRealizada)}
        />
      </Steps>
    );
  };

  return (
    <>
      <Modal
        centered
        title={'Nota fiscal de cobertura'}
        visible={isModalVisibleStatus}
        onCancel={() => setIsModalVisibleStatus(false)}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={470}
        footer={
          <Button onClick={() => setIsModalVisibleStatus(false)} type="primary">
            Fechar
          </Button>
        }
      >
        <StepsStyle>{handleStatus}</StepsStyle>
      </Modal>
      <span onClick={() => showModalStatus(props)}>{children}</span>
    </>
  );
};

export default ModalStatus;
